import { API_STORAGE_REGION_LIST } from "consts";
import { AxiosInstance } from "axios";
import { TProductStorageRegion } from "types/apis/storage-regions.types";

interface IGetStorageRegionsParams {
  httpClient: AxiosInstance;
}

export const getStorageRegions = async ({
  httpClient,
}: IGetStorageRegionsParams) =>
  httpClient
    .get<{ storageRegions: TProductStorageRegion[] }>(API_STORAGE_REGION_LIST)
    .then((res) => res.storageRegions);
